module.exports = __webpack_public_path__ + "img/1870.79143893.gif";